<template>
    <div id="parallax-world-of-ugg">
        <br>
 <section>
   <div class="img">
     <img class="" src="/TNG Image new.png" alt="img">
   </div>
   <br>
       <div class="page-break"></div>
   <div class="block">
            <div id="circle-shape-example">
              <img src="/Meeting tng.jpg" alt="pic" class="curve"  loading="lazy"> 
             <br>
                <p class="main-info" style="font-size: 20px; line-height: 1.6; color: #333;">
                  <strong>TNG TELEPHONE MANAGEMENT SYSTEM</strong> is a powerful solution designed to help you monitor, analyze, and optimize your business telephone usage. It enables you to quickly identify cost-related issues, misuse, or inefficiencies within your telephone account, giving you greater control over your communications budget.</p>

                <p class="main-info" style="font-size: 20px; line-height: 1.6; color: #333;">
                  One of its key features is the intelligent <em>'Drill Down'</em> reporting functionality, which allows users to explore data at multiple levels of detail within a single, seamless report. You can start with a high-level summary and, with just a few clicks, drill down into increasingly detailed call information—right down to individual call records—without needing to reload pages or perform separate searches.</p>

                <p class="main-info" style="font-size: 20px; line-height: 1.6; color: #333;">
                  This makes it exceptionally efficient for audits, usage reviews, or performance tracking, as all the necessary information is consolidated and easily accessible in one place. Whether you're managing a small team or a large organization, TNG simplifies call tracking and ensures complete transparency in your telecom operations.</p>
            </div>
            <br>
            <br>
            <br>
              <h5>Here's why & how TNG can help you...</h5>
            <br>
            <br>
            <div class="D1 section-flex">
          <img src="/TNG Screenshot 2.png" alt="Recording" class="section-image"  loading="lazy" />
          <div>
            <h6>Accessibility and Reports</h6>
            <ul>
              <li>Features a user-friendly, web-based interface designed for easy navigation and minimal training requirements.

</li>
              <li>Fully accessible from any device on the network using a standard web browser - no additional software installation needed.

</li>
              <li>Summary reports include powerful drill-down capabilities, allowing users to explore detailed call data directly from high-level overviews.

</li>
              <li>Built-in alert flags help identify potential call abuse, including unauthorized or private calls, for improved oversight and control.

</li>
            </ul>
          </div>
        </div>

        <br>
        <br>
        <br>

      <div class="D2 section-flex">
        <div>
          <h6>Team Management</h6>
          <ul> 
            <li>Departmental heads can be assigned customized access levels-ranging from restricted, department-specific views to full system access, including general maintenance functions - based on their role and responsibilities.

</li>
            <li>Includes a built-in phone book feature that allows users to categorize, label, and easily search for telephone numbers, streamlining identification and contact management within the system.

</li>
          </ul>
        </div>
        <img src="/TNG Screenshot 1.png" alt="Search and Playback" class="section-image"  loading="lazy" />
      </div>

        <br>
        <br>
        <br>

      <div class="D3 section-flex">
                <img src="/TNG screenshot 3.png" alt="Search and Playback" class="section-image"  loading="lazy" />
        <div>
          <h6>Technical Management</h6>
          <ul>
            <li>Installs easily on a single PC, with straightforward configuration and minimal ongoing maintenance required, making it ideal for quick deployment.

</li>
            <li>Provides full system maintenance and configuration access through a secure, password-protected administrative login to ensure system integrity.

</li>
            <li>Enables real-time data export to third-party applications using a TCP port or structured text file format, ensuring seamless integration with external systems.

</li>
            <li>Utilizes a fast, non-database architecture that boosts overall performance, increases reliability, and significantly reduces report generation times.

</li>
            <li>Includes a built-in call-costing calculator that allows for cost comparisons between different service providers, helping you make informed financial decisions.

</li>
            <li>Fully compatible with both Windows and Linux operating systems, offering flexibility across diverse IT environments.

</li>
            <li>Automatically handles data lifecycle management with scheduled deletion and archiving of older records to optimize storage and maintain performance.

</li>
            <li>Supports the use of both account codes and PIN codes for tracking and managing calls according to users or departments.

</li>
            <li>Features a simple yet powerful rate system that allows for precise call costing and easy customization based on your specific billing needs.

</li>
          </ul>
        </div>
      </div>
        <br>
      <div class="buttton">
    <div class="button"  data-tooltip="Please Click" >
      <div class="button-wrapper">
        <div class="text">TNG Brochures</div>
        <a href="/TNG Brochure 2023.pdf" class="icon" target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="2em" height="2em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path></svg>
</a>
    </div>
  </div>
  </div>

<br>
   </div>
 </section>
   <br>
 </div>
</template>

<script>
</script>

<style scoped>
.page-break {
 page-break-before: always;
 border: 1px solid rgb(0, 83, 128);
 width: 80%;
 margin-left: 10%;
 justify-content: center;
}

.section-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 80%;
  margin-left: 10%;
}

.section-image {
  width: 400px;
  height: auto;
  margin-right: 20px;
  flex-shrink: 0;
  border-radius: 25px;
  box-shadow: 0 5px 20px #333;
  transition: .3s ease-in-out ;
}

.section-image:hover {
  transform: scale(1.1);
}

/* Typography */
/**************************/
h6 { 
  font-size: 22px;
  color: white;
  font-size: 24px;
  background-color: #01213f;
  padding: 5px;

}

#parallax-world-of-ugg h5 {
 font-size:28px; 
 color:black;
 background-color: rgb(0, 83, 128);
 border-radius: 0 20px 0 20px ;
 color: white;
 padding: 8px; 
 margin:0;
}

#parallax-world-of-ugg h3 {
 font-size:20px; 
 line-height:0; 
 font-weight:400; 
 letter-spacing:8px; 
 color:black;
}

#parallax-world-of-ugg li { 
 font-weight:400; 
 font-size:20px; 
 line-height:30px;
 color: #333;
}

/* Section - Title */
/**************************/
#parallax-world-of-ugg .title {
 background: white; 
 padding: 60px; 
 margin:0 auto; 
 text-align:center;
}

#parallax-world-of-ugg .title h1 {
 font-size:30px; 
 letter-spacing:5px;
}

/* Section - Block */
/**************************/
#parallax-world-of-ugg .block {
 background: white; 
 padding: 30px; 
 width:80%; 
 margin:0 auto; 
 text-align:left;
}

.img {
 text-align: center;

}

.img img {
 width: 400px;
}
#circle-shape-example { 
  margin: 1rem; 
}
#circle-shape-example p { 
  line-height: 1.6; 
  text-align: justify;
  text-justify: inter-word;
}
#circle-shape-example .curve { 
  width: 280px; height: 260px;
  min-width: 150px;
  float: left;
  margin-right:3rem; 
  border-radius: 50%;
  -webkit-shape-outside:circle();
  shape-outside:circle();
  border: 5px solid rgb(0, 83, 128);
  box-shadow: 0 5px 20px #333;

}
/* ----- Brochure ----- */

.buttton {
  display: flex;
  justify-content: center;
}

  .button {
    --width: 320px;
    --height: 80px;
    --tooltip-height: 35px;
    --tooltip-width: 90px;
    --gap-between-tooltip-to-button: 18px;
    --button-color: rgb(0, 83, 128);
    --tooltip-color: #fff;
    width: var(--width);
    font-size: 30px;
    height: var(--height);
    background: var(--button-color);
    position: relative;
    text-align: center;
    border-radius: 0 40px 0 40px ;
    box-shadow: 0 5px 30px rgb(0, 83, 128);
    transition: background 0.3s;
    transition: 0.3s ease-in-out;
  }
  .button:hover {
    border-radius:  40px 0  40px  0 ;
    box-shadow: 0 5px 50px rgb(0, 83, 128);

  }

  .button::before {
    position: absolute;
    content: attr(data-tooltip);
    width: var(--tooltip-width);
    height: var(--tooltip-height);
    background-color: var(--tooltip-color);
    font-size: 0.9rem;
    color: #111;
    line-height: var(--tooltip-height);
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) + 10px);
    left: calc(50% - var(--tooltip-width) / 2);
  }

  .button::after {
    position: absolute;
    content: '';
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: var(--tooltip-color);
    left: calc(50% - 10px);
    bottom: calc(100% + var(--gap-between-tooltip-to-button) - 10px);
  }

  .button::after,.button::before {
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-wrapper,.text,.icon {
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    color: #fff;
  }

  .text {
    top: 0
  }

  .text,.icon {
    transition: top 0.5s;
  }

  .icon {
    color: #fff;
    top: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon svg {
    width: 50px;
    height: 50px;
  }

  .button:hover {
    background: rgb(0, 52, 79);
  }

  .button:hover .text {
    top: -100%;
  }

  .button:hover .icon {
    top: 0;
  }

  .button:hover:before,.button:hover:after {
    opacity: 1;
    visibility: visible;
  }

  .button:hover:after {
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) - 20px);
  }

  .button:hover:before {
    bottom: calc(var(--height) + var(--gap-between-tooltip-to-button));
  }


/* Media Queries */
/**************************/
@media screen and (max-width: 959px) and (min-width: 768px) {
 #parallax-world-of-ugg .block {
   padding: 40px; 
   width:620px;
 }
}
@media screen and (max-width: 767px) {
 #parallax-world-of-ugg .block {
   padding: 30px; width:420px;
 }
 #parallax-world-of-ugg h2 {
   font-size:30px;
 }
 #parallax-world-of-ugg .block {
   padding: 30px;
 }
 #parallax-world-of-ugg .parallax-one, 
 #parallax-world-of-ugg .parallax-two,
 #parallax-world-of-ugg .parallax-three {
   padding-top:100px; 
   padding-bottom:100px;
 }
}
@media screen and (max-width: 479px) {
 #parallax-world-of-ugg .block 
 {padding: 30px 15px; 
   width:290px;
 }
 #circle-shape-example .curve {
    width: 100px;
    height: 120px;
  }
  .section-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .section-image {
    width: 200px;
  }
  #parallax-world-of-ugg li {
    font-size : 15px;
    line-height: 20px;
  }
  .start-info {
    font-size :18px;
  }
  #parallax-world-of-ugg h5 {
    font-size : 20px
  }
  #circle-shape-example p { 
    font-size: 18px;
    text-align: justify;
  }
  .img img {
      width: 100%;
    }
}
</style>